import React, { useState } from 'react';
import { Accordion, AccordionItem, Collapse, Button, Modal, ModalBody, ModalHeader, Card, CardBody } from 'reactstrap';
import classnames from "classnames";
import userguidelarge from '../../assets/images/userguidelarge.svg';
import userguidesmall from '../../assets/images/userguidesmall.svg';
import groups from '../../assets/images/group.svg';
import general from '../../assets/images/general.svg';
import dbbot from '../../assets/images/dbbot.svg';
import company from '../../assets/images/company.jpg';
import Managebotuser from '../../assets/images/managebotuser.svg';
import Topup from '../../assets/images/topup.svg';

const UserGuideModal = () => {
    const [modal_standard, setmodal_standard] = useState(false);
        function tog_standard() {
            setmodal_standard(!modal_standard);
        }
        // Default Accordion
            const [col1, setcol1] = useState(true);
            const [col2, setcol2] = useState(false);
            const [col3, setcol3] = useState(false);
            const [col4, setcol4] = useState(false);
            const [col5, setcol5] = useState(false);
            const [col6, setcol6] = useState(false);
        
            const t_col1 = () => {
                setcol1(!col1);
                setcol2(false);
                setcol3(false);
                setcol4(false);
                setcol5(false);
                setcol6(false);
            };
        
            const t_col2 = () => {
                setcol2(!col2);
                setcol1(false);
                setcol3(false);
                setcol4(false);
                setcol5(false);
                setcol6(false);
            };
        
            const t_col3 = () => {
                setcol3(!col3);
                setcol1(false);
                setcol2(false);
                setcol4(false);
                setcol5(false);
                setcol6(false);
            };
            const t_col4 = () => {
                setcol4(!col4);
                setcol1(false);
                setcol2(false);
                setcol3(false);
                setcol5(false);
                setcol6(false);
            };
            const t_col5 = () => {
                setcol5(!col5);
                setcol1(false);
                setcol2(false);
                setcol3(false);
                setcol4(false);
                setcol6(false);
            };
            const t_col6 = () => {
                setcol6(!col6);
                setcol1(false);
                setcol2(false);
                setcol3(false);
                setcol4(false);
                setcol5(false);
            };
        
    
  return (
    <>
    <div>
            <Button onClick={() => tog_standard()} style={{backgroundColor:'transparent', padding:'0px', border:'none'}}> 
            <img src={userguidelarge} alt="userguide" className='largeguide'/>
            <img src={userguidesmall} alt="userguide small" className='smallguide'/>
            </Button>
    </div>
    {/* Default Modal */}
    <Modal id="myModal"
            size="lg"
            isOpen={modal_standard}
            toggle={() => {
                tog_standard();
            }}
        >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>
                   
                </ModalHeader>
                <ModalBody className='user_guide'>
                    <h2 className='heading'><img src={userguidesmall} alt="userguide small"/> Welcome to DBinsight.ai! This is your guide</h2>
                    <p className="text-muted">This quick guide will walk you through the key features and how to get started step-by-step. let's make exploring your data and efficient!</p>
                        <div className="live-preview">
                            <Accordion id="default-accordion-example">
                                <AccordionItem>
                                    <h2 className="accordion-header" id="headingOne">
                                        <button
                                            className={classnames("accordion-button", { collapsed: !col1 })} type="button" onClick={t_col1} style={{ cursor: "pointer" }} >
                                            Step 1: How to create a group
                                        </button>
                                    </h2>

                                    <Collapse isOpen={col1} className="accordion-collapse" id="collapseOne" >
                                        <div className="accordion-body">
                                            <div className="d-flex align-items-start text-muted mb-4 custom-inner">
                                                <div className="flex-grow-1 cus-left">                                                  
                                                    <p className="fs-14">A Group is the foundation of everything in DBinsight.ai. You need to create a Group before setting up any Al bot or agent.</p>
                                                    <h5 className="fs-14">• What is a Group?</h5>
                                                    <p className="fs-14">Think of it as a workspace where you can collaborate with others and manage your team's data and bots.</p>
                                                    <h5 className="fs-14">• Why is it important?</h5>
                                                    <p className="fs-14">Groups help organize your work, manage users, and allocate resources like tokens.</p>
                                                </div>
                                                <div className="flex-shrink-0 ms-3 cus-right">
                                                    <img src={groups} className="avatar-xl rounded" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </AccordionItem>
                                <AccordionItem>
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button
                                            className={classnames("accordion-button", { collapsed: !col2 })} type="button" onClick={t_col2} style={{ cursor: "pointer" }} >
                                            Step 2: Invite and Manage Group Users
                                        </button>
                                    </h2>

                                    <Collapse isOpen={col2} className="accordion-collapse" >
                                        <div className="accordion-body">
                                            <div className="d-flex align-items-center text-muted mb-4 custom-inner">
                                                <div className="flex-grow-1 cus-left">
                                                        <p className="fs-14"> Once your Group is ready, you can invite team members and assign them roles.</p>
                                                        <p className="fs-14"><b>User Roles in a Group:</b></p>
                                                    <ul>
                                                        <li> <b>Super User {'(1 per Group)'}:</b> The ultimate manager of the Group. They can handle all configurations like token allocation, user management, database connections, and more. </li>
                                                        <li><b> Admin:</b> Can manage users and view token usage details but has fewer permissions than the Super User.</li>
                                                    
                                                        
                                                        <li><b>General User:</b> Has limited access to the Group’s information.</li>
                                                    </ul>
                                                        <p><b>Why Assign Roles?</b><br/>
                                                            Assigning roles ensures secure and efficient collaboration while keeping sensitive data protected.</p>                                                 
                                                </div>
                                                <div className="flex-shrink-0 ms-3 cus-right">
                                                    <img src={company} className="avatar-xl rounded" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </AccordionItem>
                                <AccordionItem>
                                    <h2 className="accordion-header" id="headingThree">
                                        <button
                                            className={classnames("accordion-button", { collapsed: !col3 })} type="button" onClick={t_col3} style={{ cursor: "pointer" }} >
                                           Step 3: Understand Bot Types
                                        </button>
                                    </h2>
                                    <Collapse isOpen={col3} className="accordion-collapse" >
                                        <div className="accordion-body">
                                            <p className="fs-14"><b>DBinsight.ai supports two types of bots to help you access and analyze data:</b></p>
                                            <div className="d-flex align-items-start text-muted mb-4 custom-inner">
                                                <div className="flex-grow-1 cus-left">                                                 
                                                    <h5 className="fs-14">General Bot</h5>
                                                    <ul>
                                                        <li>Use this bot to add knowledge from documents, websites, or Q&A.</li>
                                                        <li>It can also retrieve information from the internet using advanced AI models.</li>
                                                    </ul>
                                                </div>
                                                <div className="flex-shrink-0 ms-3 cus-right">
                                                    <img src={general} className="avatar-xl rounded" alt="..." />
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start text-muted mb-4 custom-inner top_relate">
                                                <div className="flex-grow-1 cus-left">                                                 
                                                    <h5 className="fs-14">DB Bot</h5>
                                                    <ul>
                                                        <li>Use this bot to access and query your connected databases.</li>
                                                        <li>It can also switch to internet inquiry mode for broader searches.</li>
                                                    </ul>
                                                </div>
                                                <div className="flex-shrink-0 ms-3 cus-right">
                                                    <img src={dbbot} className="avatar-xl rounded" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </AccordionItem> 
                                <AccordionItem>
                                    <h2 className="accordion-header" id="headingfour">
                                        <button
                                            className={classnames("accordion-button", { collapsed: !col4 })} type="button" onClick={t_col4} style={{ cursor: "pointer" }} >
                                            Step 4: Create and Manage Bot Users
                                        </button>
                                    </h2>

                                    <Collapse isOpen={col4} className="accordion-collapse" >
                                        <div className="accordion-body">
                                            <div className="d-flex align-items-center text-muted mb-4 custom-inner">
                                                <div className="flex-grow-1 cus-left">
                                                        <p className="fs-14"> Once your bots are set up, you can assign users within the Group to access them.</p>
                                                        <p className="fs-14"><b>Bot User Roles</b></p>
                                                    <ul>
                                                        <li> <b>Bot Admin: {'(1 per Group)'}:</b> Manages bot settings, assigns users, creates/edit knowledge, and can interact with the bot for inquiries.</li>
                                                        <li><b> Admin:</b> Can manage users and view token usage details but has fewer permissions than the Super User.</li>
                                                    
                                                        
                                                        <li><b>Bot User and Bot Viewer:</b> Have limited access to the bot and its features.</li>
                                                    </ul>
                                                        <p><b>Why Manage Bot Users?</b><br/>
                                                        Controlling bot access ensures data security and prevents unnecessary token usage by avoiding repeated inquiries.</p>                                                 
                                                </div>
                                                <div className="flex-shrink-0 ms-3 cus-right">
                                                    <img src={Managebotuser} className="avatar-xl rounded" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </AccordionItem> 
                                <AccordionItem>
                                    <h2 className="accordion-header" id="headingfive">
                                        <button
                                            className={classnames("accordion-button", { collapsed: !col5 })} type="button" onClick={t_col5} style={{ cursor: "pointer" }} >
                                            Step 5: Manage Tokens and Subscription Plans
                                        </button>
                                    </h2>

                                    <Collapse isOpen={col5} className="accordion-collapse" >
                                        <div className="accordion-body">
                                            <div className="d-flex align-items-center text-muted mb-4 custom-inner">
                                                <div className="flex-grow-1 cus-left">
                                                        <p className="fs-14"> Tokens are the currency of DBinsight.ai and are used whenever you interact with the platform.</p>
                                                        <p className="fs-14"><b>Token Management</b></p>
                                                    <ul>
                                                        <li> Plan subscribers can allocate a token limit for each Group to control usage.</li>
                                                        <li>If needed, you can top up tokens for extra usage.</li>
                                                        <li>Remember, all tokens expire at the end of the subscription period.</li>
                                                    </ul>
                                                    <p className="fs-14"><b>Subscription Plans</b></p>
                                                    <ul>
                                                        <li>Your subscription plan determines the number of Groups, bots, and tokens available.</li>
                                                        <li>You can upgrade or downgrade your subscription plan anytime to suit your company’s changing needs.</li>
                                                    </ul>
                                                        <p>
                                                            <b>Why Manager Tokens and Plans ?</b>
                                                            <br/>
                                                            This ensures you stay within budget, maintain flexiblity, and scale the platforms as your team grows. 
                                                        </p>                                                 
                                                </div>
                                                <div className="flex-shrink-0 ms-3 cus-right">
                                                    <img src={Topup} className="avatar-xl rounded" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </AccordionItem>  
                                <AccordionItem>
                                    <h2 className="accordion-header" id="headingsix">
                                        <button
                                            className={classnames("accordion-button", { collapsed: !col6 })} type="button" onClick={t_col6} style={{ cursor: "pointer" }} >
                                            Need Help? We're Here for You!
                                        </button>
                                    </h2>

                                    <Collapse isOpen={col6} className="accordion-collapse" >
                                        <div className="accordion-body">
                                            <div className="d-flex align-items-center text-muted mb-4 custom-inner">
                                                <div className="flex-grow-1">
                                                        <p className="fs-14"> If you have any questions, comments, or encounter any bugs, feel free to reach out to us:</p>
                                                        <p className="fs-14"><b>Token Management</b></p>
                                                    <ul>
                                                        <li>Chatbot: Text us directly via the chatbot on the platform.</li>
                                                        <li>Email: Contact us at info@dbinsight.ai.</li>
                                                    </ul>                                                   
                                                        <p>We’ll do our best to get back to you as soon as possible!</p>                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </Collapse>
                                </AccordionItem>  
                            </Accordion>
                        </div>
                </ModalBody>
                {/*                                                                                                                                                                                                                                                  */}
            </Modal>
    </>
  )
}

export default UserGuideModal